<template>
  <el-dialog
    custom-class="admin-dialog-modal" title="ADD PRODUCT TO EXISTING CROSS-COMPARABLE SONG"
    :model-value="flagVisible" width="770px" :before-close="handleClose"
  >
    <div class="modal-create-cross text-that-needs-wrapping">
      <div class="create-desc">
        <div class="desc-text">
          <span>Select which exisiting Cross-Comparable song you’d like to add the {{ productName }} to. </span>
        </div>
      </div>
      <div class="create-song">
        <el-select v-model="songId" placeholder="Select existing Cross-Comparable song" style="width: 100%;">
          <el-option v-for="song in songs" :key="song._id" :value="song._id" :label="song.name"></el-option>
        </el-select>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="small" class="el-btn-blue" :loading="flagLoading.save" @click="handleSave">ADD TO SONG</el-button>
        <el-button size="small" @click="handleClose">CANCEL</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive } from 'vue'
export default {
  props: {
    role: String,
    brandId: String,
    productName: String,
    flagVisible: Boolean
  },
  emits: ['closeModal', 'afterAddSong'],
  data: function () {
    const flagLoading = reactive({
      save: false
    })
    return {
      songId: '',
      songs: [],
      flagLoading
    }
  },
  created: function () {
  },
  watch: {
    brandId: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.getCrossSongs()
        }
      }
    }
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    },
    handleSave: function () {
      if (this.songId) {
        this.handleClose()
        this.$emit('afterAddSong', { _id: this.songId })
      } else {
        this.$message({ type: 'warning', message: 'Please select a cross-comparable song' })
      }
    },
    getCrossSongs: function () {
      let url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/songs?song_type=2`
      if (this.role === 'admin') url += `&brand_id=${this.brandId}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.songs = res.data.list
        } else {
          console.error('getCrossSongs', res.msg)
        }
      }).catch(function (err) {
        console.error('getCrossSongs', err)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.modal-create-cross {
  color: black;
  .create-desc {
    .desc-text {
      font-size: 16px;
    }
  }
  .create-song {
    padding: 80px 0 60px;
  }
}
</style>
